export default __webpack_public_path__ + "static/media/orangedao.c51c408d.mp4";